import { http, defaultConfig, getUniversityUrl } from './http';
import { release } from '@/utils/release';

export const fetch = () => {
  const apiReleaseDate = localStorage.getItem('releaseDate');
  const shouldUseNewEndpoint =
    apiReleaseDate && release.isAfter(apiReleaseDate,'250908183211');

  const endpoint = shouldUseNewEndpoint
    ? '/rest/reservations/selfs'
    : '/rest/selfs';

  const baseURL = getUniversityUrl();

  return http.get(endpoint, defaultConfig(baseURL));
};
